// eslint-disable-next-line no-use-before-define
import { createTheme } from '@mui/material/styles';


export default createTheme({
  // palette: {
  //   background: {
  //     default: '#F5F6F7'
  //   }
  // },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 1200,
  //     md: 1200,
  //     lg: 1200,
  //     xl: 1536,
  //   },
  // },
  typography: {
    h1: {
      fontSize: '2rem',
    },
    h2: {
      fontSize: '1.5rem',
    },
    h3: {
      fontSize: '1.25rem',
    },
    subtitle1: {
      fontSize: '1.125rem',
    },
    body1: {
      fontSize: '1rem',
    },
    subtitle2: {
      fontSize: '0.875rem',
    },
    allVariants: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      lineHeight: 1.25,
    }
  },
  palette: {
    primary: {
      main: '#0072CE',
    }
  }
  // overrides: {
  //   MuiLink: {
  //     root: {
  //       textDecoration: 'none !important',
  //       underline: 'none',
  //     },
  //   },
  //   MuiContainer: {
  //     root:{
  //       padding: '3rem !important',
  //     }
  //   }
  // overrides: {
  //   MuiTypography: {
  //     root: {
  //       fontSize: 14,
  //       fontFamily: 'Nunito',
  //     }
  //   },
  //   MuiLink: {
  //     root: {
  //       textDecoration: 'none !important',
  //       underline: 'none',
  //     },
  //   },
  //   MuiContainer: {
  //     root:{
  //       padding: '3rem !important',
  //     }
  //   }
  // },
  // props: {
  //   MuiContainer: {
  //     maxWidth: false
  //   },
  // },
});
